(function () {
  document.documentElement.classList.remove('byb-drawer-open');
  document.body.classList.remove('byb-drawer-open', 'overflow-hidden');

  function alignCompareStrike(el) {
    if (window.rnAlignPriceStrike) window.rnAlignPriceStrike(el);
  }

  function formatMoney(cents) {
    if (typeof window.rnFormatMoney === 'function') return window.rnFormatMoney(cents);
    const amount = Math.round(Number(cents || 0));
    const whole = Math.floor(Math.abs(amount) / 100);
    const rem = Math.abs(amount) % 100;
    const sign = amount < 0 ? '-' : '';
    if (rem === 0) return sign + '$' + whole;
    return sign + '$' + whole + ',' + String(rem).padStart(2, '0');
  }

  function parseConfig(root) {
    const script = root.querySelector('[data-build-your-bundle-config]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  let bybScrollLockY = 0;
  let bybScrollLockActive = false;
  let bybScrollLockTouchHandler = null;
  let bybScrollLockWheelHandler = null;

  function isInsideBybDrawerScroll(target) {
    if (!(target instanceof Node)) return false;
    const inner = document.querySelector(
      '.rebuy-bundle-builder__group-container:not(.byb-collapsed) .rebuy-bundle-builder__group-container-inner'
    );
    return inner ? inner.contains(target) : false;
  }

  function setBybPageScrollLocked(locked) {
    const html = document.documentElement;
    const body = document.body;

    if (locked) {
      if (bybScrollLockActive) return;
      bybScrollLockActive = true;
      bybScrollLockY = window.scrollY;
      html.classList.add('byb-drawer-open');
      body.classList.add('byb-drawer-open');

      bybScrollLockTouchHandler = (event) => {
        if (isInsideBybDrawerScroll(event.target)) return;
        event.preventDefault();
      };
      bybScrollLockWheelHandler = (event) => {
        if (isInsideBybDrawerScroll(event.target)) return;
        event.preventDefault();
      };

      document.addEventListener('touchmove', bybScrollLockTouchHandler, { passive: false });
      document.addEventListener('wheel', bybScrollLockWheelHandler, { passive: false });
      return;
    }

    if (!bybScrollLockActive) return;
    bybScrollLockActive = false;

    html.classList.remove('byb-drawer-open');
    body.classList.remove('byb-drawer-open', 'overflow-hidden');

    if (bybScrollLockTouchHandler) {
      document.removeEventListener('touchmove', bybScrollLockTouchHandler);
      bybScrollLockTouchHandler = null;
    }
    if (bybScrollLockWheelHandler) {
      document.removeEventListener('wheel', bybScrollLockWheelHandler);
      bybScrollLockWheelHandler = null;
    }

    window.scrollTo(0, bybScrollLockY);
  }

  function renderProductDescriptions(scope, productMap) {
    if (!scope) return;

    scope.querySelectorAll('[data-byb-product]').forEach((block) => {
      const variantId = block.dataset.variantId;
      const product = productMap?.get(String(variantId));
      const legacyDesc = block.querySelector('.byb-product-description');
      const text = (
        block.getAttribute('data-byb-desc') ||
        product?.description ||
        legacyDesc?.textContent ||
        ''
      ).trim();
      let desc = block.querySelector('.byb-product-desc');
      const actions = block.querySelector('[data-byb-actions]');

      if (!text || !actions) {
        if (desc) desc.remove();
        return;
      }

      if (!desc) {
        desc = document.createElement('div');
        desc.className = 'byb-product-desc';
        actions.parentNode.insertBefore(desc, actions);
      } else if (desc.nextElementSibling !== actions) {
        actions.parentNode.insertBefore(desc, actions);
      }

      desc.textContent = text;
      desc.style.cssText =
        'display:block;order:3;flex:0 0 auto;width:100%;margin:4px 0 0;padding:0 4px;text-align:center;font:400 16px/1.3 MierA-Regular,MierA-Regular,sans-serif;color:#21014f;';

      if (legacyDesc && legacyDesc !== desc) legacyDesc.remove();
    });
  }

  function syncBybFooterClearance() {
    const root = document.documentElement;
    const mobile = window.matchMedia('(max-width: 989px)').matches;
    if (!mobile) {
      root.style.setProperty('--byb-footer-clearance', '0px');
      return;
    }
    const panel = document.querySelector('.rebuy-bundle-builder__group-container');
    if (!panel) {
      root.style.setProperty('--byb-footer-clearance', '72px');
      return;
    }
    if (!panel.classList.contains('byb-collapsed')) return;
    const height = Math.ceil(panel.getBoundingClientRect().height) || 72;
    root.style.setProperty('--byb-footer-clearance', `${height}px`);
  }

  function bindPageScrollPassthrough(panel) {
    if (!panel || panel.dataset.bybPageScrollBound === 'true') return;
    panel.dataset.bybPageScrollBound = 'true';

    panel.addEventListener(
      'wheel',
      (event) => {
        if (Math.abs(event.deltaY) < 1) return;
        const nestedX = event.target.closest('.rebuy-bundle-builder__group-container-body-items');
        if (nestedX && Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;

        const before = window.scrollY;
        requestAnimationFrame(() => {
          if (window.scrollY !== before) return;
          window.scrollBy(0, event.deltaY);
        });
      },
      { passive: true }
    );
  }

  function initBuilder(root) {
    if (!root || root.dataset.bybInit === 'true') return;
    root.dataset.bybInit = 'true';

    const config = parseConfig(root);
    if (!config) return;

    const packSize = config.packSize || 3;
    const discountPct = config.discountPercent || 0;
    const products = config.products || [];
    const productMap = new Map(products.map((p) => [String(p.variantId), p]));

    const els = {
      count: root.querySelector('[data-byb-count]'),
      slots: root.querySelector('[data-byb-slots]'),
      cta: root.querySelector('[data-byb-cta]'),
      panel: root.querySelector('.rebuy-bundle-builder__group-container'),
      expand: root.querySelector('[data-byb-expand]'),
      sealScope: root.querySelector('[id^="MainProduct-"]'),
    };

    bindPageScrollPassthrough(els.panel);
    syncBybFooterClearance();
    if (els.panel && typeof ResizeObserver === 'function' && !els.panel.dataset.bybClearanceBound) {
      els.panel.dataset.bybClearanceBound = 'true';
      const clearanceObserver = new ResizeObserver(() => syncBybFooterClearance());
      clearanceObserver.observe(els.panel);
      window.addEventListener('resize', syncBybFooterClearance, { passive: true });
    }

    const moneyRegex =
      /([€$£]\s?\d[\d\s.,]*(?:\s?(?:US|USD|EUR|GBP|CAD|AUD))?|\d[\d\s.,]*\s?(?:\$|€|£|USD|EUR|GBP|CAD|AUD|US))/i;

    let slots = [];
    let sealObserver = null;
    let lastKnownSellingPlanId = '';
    let lastKnownSubscriptionChoice = 'flexible';

    function extractNumericString(value) {
      if (value == null) return '';
      const str = String(value).trim();
      if (/^\d+$/.test(str)) return str;
      const gidMatch = str.match(/(\d+)\s*$/);
      return gidMatch ? gidMatch[1] : '';
    }

    function findSellingPlanInputValue(scope) {
      if (!scope) return '';
      const candidates = [
        scope.querySelector('input[name="selling_plan"]:checked'),
        scope.querySelector('input[name="selling_plan"]'),
        scope.querySelector('input[name*="selling_plan"]:checked'),
        scope.querySelector('input[name*="selling_plan"]'),
        scope.querySelector('select[name="selling_plan"]'),
        scope.querySelector('select[name*="selling_plan"]'),
      ];
      for (const field of candidates) {
        if (!field) continue;
        const value = field.tagName === 'SELECT' ? field.value : field.value;
        const normalized = extractNumericString(value);
        if (normalized) return normalized;
      }
      return '';
    }

    function isSealOptionSelected(option) {
      if (!(option instanceof HTMLElement)) return false;
      const radio = option.querySelector('.sls-option[type="radio"]');
      if (radio instanceof HTMLInputElement && radio.checked) return true;
      if (option.classList.contains('sls-active')) return true;
      return !!option.querySelector('.sls-option[type="radio"]:checked');
    }

    function getCheckedSealRadio() {
      if (!els.sealScope) return null;
      return els.sealScope.querySelector('.sls-option[type="radio"]:checked');
    }

    function isFlexibleSubscriptionSelected() {
      if (!els.sealScope) return false;

      const flexibleOption = findOptionContainer(els.sealScope, 'flexible');
      const oneTimeOption = findOptionContainer(els.sealScope, 'one-time');

      if (oneTimeOption && isSealOptionSelected(oneTimeOption)) return false;
      if (flexibleOption?.classList.contains('sls-active')) return true;

      const checkedRadio = getCheckedSealRadio();
      if (checkedRadio instanceof HTMLInputElement) {
        if (checkedRadio.value === 'one_time') return false;
        if (checkedRadio.value && checkedRadio.value !== 'one_time') return true;
      }

      if (flexibleOption && isSealOptionSelected(flexibleOption)) return true;

      if (lastKnownSubscriptionChoice === 'one-time') return false;
      if (lastKnownSubscriptionChoice === 'flexible') return true;

      return !!findSellingPlanInputValue(els.sealScope);
    }

    function syncSealSelectionBeforeAdd() {
      if (!els.sealScope) return;

      const oneTimeOption = findOptionContainer(els.sealScope, 'one-time');
      const flexibleOption = findOptionContainer(els.sealScope, 'flexible');

      if (oneTimeOption && isSealOptionSelected(oneTimeOption)) {
        lastKnownSubscriptionChoice = 'one-time';
        return;
      }

      const shouldUseFlexible =
        flexibleOption?.classList.contains('sls-active') ||
        lastKnownSubscriptionChoice === 'flexible' ||
        (flexibleOption && isSealOptionSelected(flexibleOption));

      if (!shouldUseFlexible) return;

      const flexRadio = flexibleOption?.querySelector('.sls-option[type="radio"]');
      if (flexRadio instanceof HTMLInputElement && !flexRadio.checked) {
        flexRadio.click();
      }

      lastKnownSubscriptionChoice = 'flexible';
      const planId = findSellingPlanInputValue(els.sealScope);
      if (planId) lastKnownSellingPlanId = planId;
    }

    function getSubscriptionPlanName(variantId, planId) {
      const product = productMap.get(String(variantId));
      const plan = product?.sellingPlans?.find((entry) => String(entry.id) === String(planId));
      return plan?.name || 'Monthly subscription';
    }

    function normalizePlanLabel(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function resolveSellingPlanId(variantId) {
      const product = productMap.get(String(variantId));
      if (!product?.sellingPlans?.length) return null;

      const plans = product.sellingPlans;

      const sealPlanId = lastKnownSellingPlanId || findSellingPlanInputValue(els.sealScope);
      if (sealPlanId) {
        const exact = plans.find((plan) => String(plan.id) === String(sealPlanId));
        if (exact) return exact.id;
      }

      const flexiblePlan = plans.find((plan) => {
        const name = normalizePlanLabel(plan.name);
        return (
          name.includes('flexible') ||
          name.includes('subscription') ||
          name.includes('monthly') ||
          name.includes('sans engagement') ||
          name.includes('abonnement')
        );
      });
      if (flexiblePlan) return flexiblePlan.id;

      return plans.length === 1 ? plans[0].id : plans[0]?.id ?? null;
    }

    function buildCartItems(grouped) {
      const useSubscription = isFlexibleSubscriptionSelected();

      return [...grouped.entries()].map(([variantId, quantity]) => {
        const product = productMap.get(String(variantId));
        const item = {
          id: parseInt(variantId, 10),
          quantity,
          properties: {
            Bundle: `${packSize} PACK`,
          },
        };

        if (useSubscription) {
          const planId = resolveSellingPlanId(variantId);
          if (planId) {
            item.selling_plan = parseInt(String(planId), 10);
            item.properties.Subscription = getSubscriptionPlanName(variantId, planId);
          }
        }

        return item;
      });
    }

    async function applyBundleDiscountCode() {
      const code = String(config.bundleDiscountCode || '').trim();
      if (!code) return null;

      const root = window.Shopify?.routes?.root || '/';
      try {
        const res = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: code }),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) {
          console.error('Build Your Bundle: discount code failed', data.description || data.message || code);
        }
        return data;
      } catch (e) {
        console.error('Build Your Bundle: discount code request failed', e);
        return null;
      }
    }

    function getCartSectionIds() {
      const ids = new Set(['cart-drawer', 'cart-icon-bubble']);
      const drawer = document.querySelector('cart-drawer');

      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        drawer.getSectionsToRender().forEach((section) => {
          if (section?.id) ids.add(section.id);
        });
      }

      document.querySelectorAll('cart-drawer, cart-icon-bubble, #cart-icon-bubble').forEach((node) => {
        const section = node.closest('[id^="shopify-section-"]');
        if (section?.id) ids.add(section.id.replace('shopify-section-', ''));
      });

      return [...ids];
    }

    function hasRenderableCartSections(sections, drawer) {
      if (!sections || typeof sections !== 'object') return false;

      const required =
        drawer && typeof drawer.getSectionsToRender === 'function'
          ? drawer.getSectionsToRender().map((section) => section.id)
          : ['cart-drawer', 'cart-icon-bubble'];

      return required.every((id) => typeof sections[id] === 'string' && sections[id].trim());
    }

    function renderCartSections(sections, drawer) {
      if (!sections || typeof sections !== 'object') return false;

      const targets =
        drawer && typeof drawer.getSectionsToRender === 'function'
          ? drawer.getSectionsToRender()
          : [
              { id: 'cart-drawer', selector: '#CartDrawer' },
              { id: 'cart-icon-bubble' },
            ];

      let updated = false;

      targets.forEach((target) => {
        const html = sections[target.id];
        if (typeof html !== 'string' || !html.trim()) return;

        const parsed = new DOMParser().parseFromString(html, 'text/html');
        let inner = null;

        if (target.selector) {
          inner = parsed.querySelector(target.selector)?.innerHTML || null;
        }

        if (!inner) {
          inner =
            parsed.querySelector('.shopify-section')?.innerHTML ||
            parsed.querySelector(`#shopify-section-${target.id}`)?.innerHTML ||
            parsed.body.innerHTML;
        }

        if (!inner) return;

        if (target.selector?.startsWith('#')) {
          const node = document.querySelector(target.selector);
          if (node) {
            node.innerHTML = inner;
            updated = true;
            return;
          }
        }

        const wrapper =
          document.getElementById(`shopify-section-${target.id}`) || document.getElementById(target.id);
        if (wrapper) {
          wrapper.innerHTML = inner;
          updated = true;
        }
      });

      return updated;
    }

    function notifyCartUpdate(cartData) {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true, detail: cartData })
      );

      if (typeof window.publish === 'function') {
        window.publish('cart-update', { source: 'build-your-bundle', cartData });
      }
    }

    async function openCartAfterAdd(data) {
      const drawer = document.querySelector('cart-drawer');
      const cartNotification = document.querySelector('cart-notification');
      const root = window.Shopify?.routes?.root || '/';
      const cartData = { ...(data || {}) };

      try {
        const sectionIds = getCartSectionIds().join(',');
        const sectionsRes = await fetch(`${root}cart?sections=${sectionIds}`);
        if (sectionsRes.ok) {
          cartData.sections = {
            ...(cartData.sections || {}),
            ...(await sectionsRes.json()),
          };
        }
      } catch (e) {
        console.error('Build Your Bundle: cart sections refresh failed', e);
      }

      notifyCartUpdate(cartData);

      let opened = false;

      if (
        drawer &&
        typeof drawer.renderContents === 'function' &&
        hasRenderableCartSections(cartData.sections, drawer)
      ) {
        try {
          drawer.renderContents(cartData);
          opened = drawer.classList.contains('active');
        } catch (e) {
          console.error('Build Your Bundle: cart-drawer renderContents failed', e);
        }
      }

      if (!opened) {
        renderCartSections(cartData.sections, drawer);
      }

      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
        opened = true;
      } else if (cartNotification && typeof cartNotification.open === 'function') {
        cartNotification.open();
        opened = true;
      }

      if (!opened) {
        window.location.href = `${root}cart`;
      }
    }

    function bindSealSellingPlanListener() {
      if (root.dataset.bybSealPlanBound === 'true') return;
      root.dataset.bybSealPlanBound = 'true';

      document.addEventListener('sealsubs:selling_plan_changed', (event) => {
        const nextId = extractNumericString(event?.detail?.selling_plan_id);
        lastKnownSellingPlanId = nextId || '';
        if (nextId) lastKnownSubscriptionChoice = 'flexible';
        syncSealOptionCollapse(findSealRoot());
      });

      els.sealScope?.addEventListener('change', (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) return;
        if (!target.matches('.sls-option[type="radio"]')) return;

        lastKnownSubscriptionChoice = target.value === 'one_time' ? 'one-time' : 'flexible';
        const planId = findSellingPlanInputValue(els.sealScope);
        if (planId) lastKnownSellingPlanId = planId;
        window.requestAnimationFrame(() => syncSealOptionCollapse(findSealRoot()));
      });

      els.sealScope?.addEventListener(
        'click',
        (event) => {
          if (event.target?.closest?.('.sls-option-container, .sls-option[type="radio"]')) {
            window.requestAnimationFrame(() => syncSealOptionCollapse(findSealRoot()));
          }
        },
        true
      );
    }

    function bindSealFormIntercept() {
      if (!els.sealScope || root.dataset.bybSealFormBound === 'true') return;

      const attach = () => {
        els.sealScope.querySelectorAll('form[data-type="add-to-cart-form"], product-form form').forEach((form) => {
          if (!(form instanceof HTMLFormElement) || form.dataset.bybSubmitBound === 'true') return;
          form.dataset.bybSubmitBound = 'true';
          form.addEventListener('submit', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (totalCount() === packSize && els.cta && !els.cta.disabled) {
              els.cta.click();
            }
          });
        });
      };

      attach();
      root.dataset.bybSealFormBound = 'true';
    }

    function getGroupedSlots() {
      const grouped = new Map();
      slots.forEach((slot) => {
        grouped.set(slot.variantId, (grouped.get(slot.variantId) || 0) + 1);
      });
      return grouped;
    }

    function getBundleTotals() {
      let subtotal = 0;
      getGroupedSlots().forEach((qty, variantId) => {
        const product = productMap.get(String(variantId));
        if (product) subtotal += product.price * qty;
      });
      const discounted = Math.round(subtotal * (1 - discountPct / 100));
      return { subtotal, discounted };
    }

    function getSealDisplayPrices() {
      if (totalCount() !== packSize) return null;

      const { subtotal, discounted } = getBundleTotals();

      return {
        originalCents: subtotal,
        oneTimeCents: discounted,
        flexibleCents: Math.round(discounted * 0.7),
      };
    }

    function hideSealPrices(scope) {
      scope.querySelectorAll('.sls-option-container').forEach((option) => {
        if (!(option instanceof HTMLElement)) return;
        const text = (option.textContent || '').toLowerCase().replace(/\s+/g, ' ');
        const isPurchaseOption =
          text.includes('one-time purchase') ||
          text.includes('one time purchase') ||
          text.includes('flexible subscription');
        if (!isPurchaseOption) return;

        option
          .querySelectorAll(
            '.sls-price-container, .sls-selling-plan-group-price, .sls-total-price, .sls-price, [data-byb-compare-price]'
          )
          .forEach((el) => {
            if (!(el instanceof HTMLElement)) return;
            el.style.setProperty('display', 'none', 'important');
            el.setAttribute('data-byb-price-hidden', 'true');
          });
      });
    }

    function showSealPrices(scope) {
      scope.querySelectorAll('[data-byb-price-hidden]').forEach((el) => {
        if (!(el instanceof HTMLElement)) return;
        el.style.removeProperty('display');
        el.removeAttribute('data-byb-price-hidden');
      });
    }

    function findSealRoot() {
      return els.sealScope?.querySelector('.sealsubs-container, [class*="sls-"]') || null;
    }

    const SEAL_CHECKMARK_SVG =
      '<span class="byb-seal-check" aria-hidden="true"><svg class="byb-seal-check__icon" width="17" height="17" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.333 4L6 11.333 2.667 8" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" fill="none"></path></svg></span>';

    function fixSealCheckmarkStyles(sealRoot) {
      if (!sealRoot) return;
      sealRoot.querySelectorAll('.sls-selling-plan-description-content svg, .byb-seal-check__icon').forEach((svg) => {
        if (!(svg instanceof SVGElement)) return;
        svg.style.setProperty('display', 'inline-block', 'important');
        svg.style.setProperty('fill', 'none', 'important');
        svg.style.setProperty('stroke', 'currentColor', 'important');
        svg.style.setProperty('color', '#ffffff', 'important');
        svg.querySelectorAll('path').forEach((path) => {
          if (!(path instanceof SVGPathElement)) return;
          path.style.setProperty('fill', 'none', 'important');
          path.style.setProperty('stroke', 'currentColor', 'important');
        });
      });
    }

    function stripLeadingCheckmark(html) {
      return (html || '')
        .replace(/^\s*(?:<span[^>]*>\s*)?<svg[\s\S]*?<\/svg>\s*(?:<\/span>\s*)?/i, '')
        .trim();
    }

    let sealDescriptionPartsCache = null;

    function getDescriptionParts(description) {
      const bybList = description.querySelector('.byb-benefits-list');
      if (bybList) {
        const lines = bybList.querySelectorAll('.byb-benefit-line');
        if (lines.length) {
          const parts = [...lines]
            .map((line) => {
              const textEl = line.querySelector('.byb-benefit-text');
              return (textEl || line).innerHTML.trim();
            })
            .filter(Boolean);
          if (parts.length >= 2) sealDescriptionPartsCache = parts;
          return parts;
        }
      }

      const html = description.innerHTML || '';
      if (/<br\b/i.test(html)) {
        const parts = html.split(/<br\b[^>]*>/gi).map(stripLeadingCheckmark).filter(Boolean);
        if (parts.length >= 2) sealDescriptionPartsCache = parts;
        return parts;
      }

      return sealDescriptionPartsCache || [];
    }

    function descriptionNeedsCheckmarkSync(description) {
      const parts = getDescriptionParts(description);
      if (parts.length < 2) return false;
      const benefitLines = description.querySelectorAll('.byb-seal-benefit-line');
      if (benefitLines.length >= parts.length) return false;
      const html = description.innerHTML || '';
      const svgCount = (html.match(/byb-seal-check__icon|width="17"/g) || []).length;
      return svgCount < parts.length;
    }

    function syncSealDescriptionWithPdp(sealRoot) {
      pauseSealObserverDuring(() => {
        sealRoot.querySelectorAll('.sls-selling-plan-description-content').forEach((description) => {
          if (!(description instanceof HTMLElement)) return;
          if (!descriptionNeedsCheckmarkSync(description)) return;

          const parts = getDescriptionParts(description);
          if (parts.length < 2) return;

          description.innerHTML = parts
            .map(
              (part) =>
                `<div class="byb-seal-benefit-line">${SEAL_CHECKMARK_SVG}<span class="byb-seal-benefit-text">${part}</span></div>`
            )
            .join('');
        });
        fixSealCheckmarkStyles(sealRoot);
      });
    }

    function syncSealOptionCollapse(sealRoot) {
      if (!sealRoot) return;

      sealRoot.querySelectorAll('.sls-option-container').forEach((option) => {
        if (!(option instanceof HTMLElement)) return;
        const selected = isSealOptionSelected(option);

        option
          .querySelectorAll('.sls-selling-plan-description-content, .sls-one-time-description-content')
          .forEach((panel) => {
            if (!(panel instanceof HTMLElement)) return;
            if (selected) {
              panel.style.removeProperty('display');
              panel.style.removeProperty('max-height');
              panel.style.removeProperty('overflow');
              panel.style.removeProperty('margin');
              panel.style.removeProperty('padding');
            } else {
              panel.style.setProperty('display', 'none', 'important');
              panel.style.setProperty('max-height', '0', 'important');
              panel.style.setProperty('overflow', 'hidden', 'important');
              panel.style.setProperty('margin', '0', 'important');
              panel.style.setProperty('padding', '0', 'important');
            }
          });

        if (!selected) {
          option.style.removeProperty('min-height');
          option.style.removeProperty('height');
        }
      });
    }

    function syncSealWidget() {
      const sealRoot = findSealRoot();
      if (sealRoot) {
        syncSealDescriptionWithPdp(sealRoot);
        fixSealCheckmarkStyles(sealRoot);
        syncSealOptionCollapse(sealRoot);
      }
      scheduleSealPriceUpdates();
    }

    function scheduleSealDescriptionSync() {
      const run = () => {
        const sealRoot = findSealRoot();
        if (sealRoot) syncSealDescriptionWithPdp(sealRoot);
      };
      run();
      window.setTimeout(run, 120);
      window.setTimeout(run, 350);
      window.setTimeout(run, 800);
      window.setTimeout(run, 1500);
      window.setTimeout(run, 3000);
    }

    function getOptionLabelText(option) {
      if (!(option instanceof HTMLElement)) return '';
      const radio = option.querySelector(
        '.sls-selling-plan-group-first-line[aria-label], [role="radio"][aria-label]'
      );
      const label = option.querySelector('.sls-selling-plan-group-name, label');
      return [radio?.getAttribute('aria-label'), label?.textContent, option.getAttribute('aria-label')]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function findOptionContainer(scope, type) {
      return Array.from(scope.querySelectorAll('.sls-option-container')).find((option) => {
        const text = getOptionLabelText(option);
        if (type === 'one-time') {
          return text.includes('one-time') || text.includes('one time');
        }
        return text.includes('flexible subscription') || text.includes('flexible');
      });
    }

    function findPrimaryPriceNode(option) {
      if (!option) return null;
      const selectors = [
        '.sls-selling-plan-group-first-line .money',
        '.sls-selling-plan-group-price .money',
        '.sls-total-price .money',
        '.sls-price .money',
        '.seal-money',
      ];
      for (const selector of selectors) {
        const node = option.querySelector(selector);
        if (node instanceof HTMLElement) return node;
      }
      return (
        Array.from(option.querySelectorAll('*')).find((node) => {
          if (!(node instanceof HTMLElement)) return false;
          if (node.children.length !== 0) return false;
          const txt = (node.textContent || '').trim();
          if (!txt || /%/.test(txt)) return false;
          moneyRegex.lastIndex = 0;
          return /\$|US|USD/i.test(txt) && moneyRegex.test(txt);
        }) || null
      );
    }

    function removeComparePrice(option) {
      const priceNode = findPrimaryPriceNode(option);
      const container = priceNode?.closest('.sls-price');
      container?.querySelector('[data-byb-compare-price]')?.remove();
    }

    function ensureComparePriceNode(priceNode) {
      const container = priceNode.closest('.sls-price');
      if (!container) return null;

      let compareNode = container.querySelector('[data-byb-compare-price]');
      if (!compareNode) {
        compareNode = document.createElement('span');
        compareNode.className = 'money sls-original-price';
        compareNode.setAttribute('data-byb-compare-price', 'true');
        compareNode.setAttribute('data-byb-price', 'true');
        priceNode.insertAdjacentElement('afterend', compareNode);
      }
      return compareNode;
    }

    function setOptionPrice(option, formatted, priceType, compareFormatted) {
      const priceNode = findPrimaryPriceNode(option);
      if (!priceNode) return;
      priceNode.setAttribute('data-rush-price-type', priceType);
      priceNode.setAttribute('data-byb-price', 'true');
      priceNode.textContent = formatted;

      if (!compareFormatted || compareFormatted === formatted) {
        removeComparePrice(option);
        return;
      }

      const compareNode = ensureComparePriceNode(priceNode);
      if (!compareNode) return;
      compareNode.setAttribute('data-byb-price', 'true');
      compareNode.textContent = compareFormatted;
      alignCompareStrike(compareNode);
      window.requestAnimationFrame(() => alignCompareStrike(compareNode));
    }

    function paintPurchasePrices() {
      const ui = root.querySelector('[data-byb-purchase]');
      if (!ui) return;
      const prices = getSealDisplayPrices();

      ui.querySelectorAll('[data-byb-purchase-prices]').forEach((el) => {
        if (!(el instanceof HTMLElement)) return;
        const saleEl = el.querySelector('[data-byb-purchase-sale]');
        const compareEl = el.querySelector('[data-byb-purchase-compare]');
        if (!prices) {
          el.classList.remove('is-visible');
          if (saleEl) saleEl.textContent = '';
          if (compareEl) compareEl.textContent = '';
          return;
        }

        const saleCents = el.getAttribute('data-byb-purchase-prices') === 'subscription'
          ? prices.flexibleCents
          : prices.oneTimeCents;
        const compareCents = prices.originalCents;
        el.classList.add('is-visible');
        if (saleEl) saleEl.textContent = formatMoney(saleCents);
        if (compareEl) {
          const showCompare = compareCents && compareCents !== saleCents;
          compareEl.hidden = !showCompare;
          compareEl.textContent = showCompare ? formatMoney(compareCents) : '';
        }
      });
    }

    function updateSealPrices() {
      const scope = els.sealScope;
      if (!scope) return;

      pauseSealObserverDuring(() => {
        paintPurchasePrices();
        if (totalCount() !== packSize) {
          hideSealPrices(scope);
          return;
        }

        showSealPrices(scope);

        const prices = getSealDisplayPrices();
        if (!prices) return;

        const originalFormatted = formatMoney(prices.originalCents);
        setOptionPrice(
          findOptionContainer(scope, 'one-time'),
          formatMoney(prices.oneTimeCents),
          'one-time',
          originalFormatted
        );
        setOptionPrice(
          findOptionContainer(scope, 'flexible'),
          formatMoney(prices.flexibleCents),
          'flexible',
          originalFormatted
        );
      });
    }

    function scheduleSealPriceUpdates() {
      updateSealPrices();
      window.setTimeout(updateSealPrices, 120);
      window.setTimeout(updateSealPrices, 350);
      const alignAll = () => {
        els.sealScope
          ?.querySelectorAll('[data-byb-compare-price], .sls-original-price')
          .forEach(alignCompareStrike);
      };
      window.requestAnimationFrame(alignAll);
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(alignAll);
      }
    }

    let sealObserverPaused = false;
    let sealObserverDebounceRaf = null;
    let sealObserverDebounceTimer = null;

    function pauseSealObserverDuring(fn) {
      sealObserverPaused = true;
      try {
        fn();
      } finally {
        sealObserverPaused = false;
      }
    }

    function scheduleSealObserverWork() {
      if (sealObserverPaused) return;
      if (sealObserverDebounceRaf !== null || sealObserverDebounceTimer !== null) return;

      sealObserverDebounceRaf = window.requestAnimationFrame(() => {
        sealObserverDebounceRaf = null;
        sealObserverDebounceTimer = window.setTimeout(() => {
          sealObserverDebounceTimer = null;
          if (totalCount() === packSize) {
            updateSealPrices();
          }
          const sealRoot = findSealRoot();
          if (!sealRoot) return;
          const needsCheckmarks = [...sealRoot.querySelectorAll('.sls-selling-plan-description-content')].some(
            (description) => description instanceof HTMLElement && descriptionNeedsCheckmarkSync(description)
          );
          if (needsCheckmarks) syncSealDescriptionWithPdp(sealRoot);
          syncSealOptionCollapse(sealRoot);
        }, 60);
      });
    }

    function bindSealObserver() {
      if (!els.sealScope) return;

      const attach = () => {
        const sealRoot = findSealRoot();
        if (!sealRoot) {
          window.setTimeout(attach, 200);
          return;
        }

        if (els.sealScope.dataset.bybSealBound !== 'true') {
          els.sealScope.dataset.bybSealBound = 'true';
          if (sealObserver) sealObserver.disconnect();
          sealObserver = new MutationObserver(() => {
            scheduleSealObserverWork();
          });
          sealObserver.observe(sealRoot, { childList: true, subtree: true });
        }

        syncSealWidget();
        scheduleSealDescriptionSync();
        bindSealFormIntercept();
      };

      attach();
    }

    function totalCount() {
      return slots.length;
    }

    function variantCount(variantId) {
      return slots.filter((s) => s.variantId === String(variantId)).length;
    }

    function isFull() {
      return totalCount() >= packSize;
    }

    function slotHtml(index, slot) {
      if (slot) {
        const product = productMap.get(slot.variantId);
        if (!product) return '';
        return `
            <div class="byb-bundle-slot" role="listitem">
              <div class="byb-bundle-slot__visual">
                <div class="rebuy-bundle-builder__product-holder-data">
                  <div class="rebuy-bundle-builder__product-holder-info--left">
                    <div class="rebuy-bundle-builder__product-holder-media rebuy-product-media">
                      <img src="${product.image}" alt="${product.title.replace(/"/g, '&quot;')}" loading="lazy" width="115" height="115">
                    </div>
                  </div>
                  <div class="rebuy-bundle-builder__product-holder-info--right">
                    <button type="button" class="rebuy-bundle-builder__product-holder-info-delete" data-byb-remove="${index}" aria-label="Remove ${product.title.replace(/"/g, '&quot;')} from bundle"></button>
                  </div>
                </div>
                <h3 class="byb-bundle-slot__title rebuy-bundle-builder__product-holder-info-title rebuy-product-title">${product.title}</h3>
              </div>
            </div>`;
      }

      const emptySlotImage = config.emptySlotImage || '';
      return `
            <div class="byb-bundle-slot" role="listitem">
              <div class="byb-bundle-slot__visual">
                <div class="rebuy-bundle-builder__product-holder-template" aria-hidden="true">
                  <img class="byb-empty-slot__image" src="${emptySlotImage}" alt="" width="115" height="115" loading="lazy" decoding="async" aria-hidden="true" onerror="this.remove()">
                </div>
              </div>
            </div>`;
    }

    function renderPanel() {
      if (!els.slots) return;

      const scrollLeft = els.slots.scrollLeft;

      for (let i = 0; i < packSize; i += 1) {
        const slot = slots[i];
        const stateKey = slot ? `filled-${slot.variantId}` : 'empty';
        let item = els.slots.children[i];

        if (!item || !item.classList.contains('byb-bundle-slot') || item.dataset.stateKey !== stateKey) {
          const html = slotHtml(i, slot);
          if (item) {
            item.outerHTML = html;
          } else {
            els.slots.insertAdjacentHTML('beforeend', html);
          }
          item = els.slots.children[i];
        }

        item.dataset.slotIndex = String(i);
        item.dataset.stateKey = stateKey;
        item.setAttribute('role', 'listitem');
        item.setAttribute(
          'aria-label',
          slot ? productMap.get(slot.variantId)?.title || 'Bundle product' : 'Bundle product'
        );
      }

      while (els.slots.children.length > packSize) {
        els.slots.removeChild(els.slots.lastChild);
      }

      els.slots.scrollLeft = scrollLeft;
    }

    function renderProductActions() {
      root.querySelectorAll('[data-byb-product]').forEach((block) => {
        const variantId = block.dataset.variantId;
        const qty = variantCount(variantId);
        const actions = block.querySelector('[data-byb-actions]');
        if (!actions) return;
        const product = productMap.get(String(variantId));
        if (!product) return;

        if (qty === 0) {
          actions.innerHTML = `
            <div class="rebuy-bundle-builder__product-quantity">
              <button type="button" class="rebuy-button wh-magnetic-button" data-byb-add="${variantId}" aria-label="Add the product, ${product.title.replace(/"/g, '&quot;')} to Cart"${isFull() ? ' disabled' : ''}>
                <span class="wh-magnetic-button__clip" aria-hidden="true">
                  <span class="wh-magnetic-button__fill" aria-hidden="true"></span>
                </span>
                <span class="wh-magnetic-button__label">ADD</span>
              </button>
            </div>`;
        } else {
          actions.innerHTML = `
            <div class="rebuy-bundle-builder__product-quantity">
              <div class="rebuy-bundle-builder__item-quantity-widget">
                <button type="button" class="rebuy-bundle-builder__item-quantity-widget-button" data-byb-dec="${variantId}" aria-label="Decrease quantity of ${product.title.replace(/"/g, '&quot;')}">
                  <i class="rebuy-grey far fa-minus" aria-hidden="true"></i>
                </button>
                <span class="rebuy-bundle-builder__item-quantity-widget-label" tabindex="0">${qty}</span>
                <button type="button" class="rebuy-bundle-builder__item-quantity-widget-button" data-byb-inc="${variantId}" aria-label="Increase quantity of ${product.title.replace(/"/g, '&quot;')}"${isFull() ? ' disabled' : ''}>
                  <i class="rebuy-grey far fa-plus" aria-hidden="true"></i>
                </button>
              </div>
            </div>`;
        }
      });

      renderProductDescriptions(root, productMap);

      root.querySelectorAll('[data-byb-add]').forEach((btn) => {
        btn.addEventListener('click', () => addVariant(btn.getAttribute('data-byb-add')));
      });
      root.querySelectorAll('[data-byb-inc]').forEach((btn) => {
        btn.addEventListener('click', () => addVariant(btn.getAttribute('data-byb-inc')));
      });
      root.querySelectorAll('[data-byb-dec]').forEach((btn) => {
        btn.addEventListener('click', () => removeOneVariant(btn.getAttribute('data-byb-dec')));
      });
    }

    function renderSummary() {
      if (els.count) els.count.textContent = String(totalCount());
      if (els.cta) els.cta.disabled = totalCount() !== packSize;
      syncSealWidget();
    }

    function addVariant(variantId) {
      if (!variantId || isFull()) return;
      slots.push({ variantId: String(variantId) });
      renderAll();
    }

    function removeOneVariant(variantId) {
      const id = String(variantId);
      for (let i = slots.length - 1; i >= 0; i -= 1) {
        if (slots[i].variantId === id) {
          slots.splice(i, 1);
          break;
        }
      }
      renderAll();
    }

    function renderAll() {
      renderPanel();
      renderProductActions();
      renderSummary();
    }

    if (els.slots && !els.slots.dataset.bybBound) {
      els.slots.dataset.bybBound = 'true';
      els.slots.addEventListener('click', (event) => {
        const btn = event.target.closest('[data-byb-remove]');
        if (!btn) return;
        const index = parseInt(btn.getAttribute('data-byb-remove'), 10);
        if (Number.isNaN(index)) return;
        slots.splice(index, 1);
        renderAll();
      });
    }

    if (els.expand && els.panel) {
      const header = root.querySelector('.rebuy-bundle-builder__group-container-header');
      const mobileQuery = window.matchMedia('(max-width: 989px)');
      const syncExpandState = () => {
        const collapsed = els.panel.classList.contains('byb-collapsed');
        els.expand.setAttribute('aria-expanded', String(!collapsed));
        if (mobileQuery.matches) {
          setBybPageScrollLocked(!collapsed);
        } else {
          setBybPageScrollLocked(false);
        }
        syncBybFooterClearance();
      };
      const togglePanel = () => {
        els.panel.classList.toggle('byb-collapsed');
        syncExpandState();
      };
      // On mobile the panel is a sticky bottom drawer: start collapsed so the
      // product grid stays usable, then let the shopper open it. On desktop it
      // stays fully expanded (the collapse styles are mobile-only anyway).
      if (mobileQuery.matches) {
        els.panel.classList.add('byb-collapsed');
      } else {
        els.panel.classList.remove('byb-collapsed');
      }
      syncExpandState();
      if (header) header.addEventListener('click', togglePanel);
      els.expand.addEventListener('click', togglePanel);
      const handleBreakpointChange = (event) => {
        if (event.matches) {
          els.panel.classList.add('byb-collapsed');
        } else {
          els.panel.classList.remove('byb-collapsed');
        }
        syncExpandState();
      };
      if (typeof mobileQuery.addEventListener === 'function') {
        mobileQuery.addEventListener('change', handleBreakpointChange);
      } else if (typeof mobileQuery.addListener === 'function') {
        mobileQuery.addListener(handleBreakpointChange);
      }
    }

    if (els.cta) {
      els.cta.addEventListener('click', async () => {
        if (totalCount() !== packSize) return;

        const grouped = new Map();
        slots.forEach((slot) => {
          grouped.set(slot.variantId, (grouped.get(slot.variantId) || 0) + 1);
        });

        syncSealSelectionBeforeAdd();

        const checkedRadio = getCheckedSealRadio();
        if (checkedRadio instanceof HTMLInputElement) {
          lastKnownSubscriptionChoice = checkedRadio.value === 'one_time' ? 'one-time' : 'flexible';
          if (lastKnownSubscriptionChoice === 'flexible') {
            const planId = findSellingPlanInputValue(els.sealScope);
            if (planId) lastKnownSellingPlanId = planId;
          }
        }

        const useSubscription = isFlexibleSubscriptionSelected();
        const items = buildCartItems(grouped);

        if (useSubscription) {
          const missingPlans = [...grouped.keys()].filter((variantId) => !resolveSellingPlanId(variantId));
          if (missingPlans.length) {
            console.error('Build Your Bundle: missing Seal selling plan for variants', missingPlans);
          }
          const missingSellingPlan = items.filter((item) => !item.selling_plan);
          if (missingSellingPlan.length) {
            console.error('Build Your Bundle: cart items missing selling_plan', missingSellingPlan);
          }
        }

        els.cta.disabled = true;
        const label = els.cta.querySelector('[data-byb-cta-label]');
        const prev = label ? label.textContent : '';
        if (label) label.textContent = config.loadingLabel || 'Adding...';

        try {
          const cartUrl = window.Shopify?.routes?.root
            ? `${window.Shopify.routes.root}cart/add.js`
            : '/cart/add.js';
          const res = await fetch(cartUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items,
              sections: getCartSectionIds().join(','),
              sections_url: `${window.Shopify?.routes?.root || '/'}cart`,
            }),
          });

          const data = await res.json().catch(() => ({}));
          if (!res.ok) {
            throw new Error(data.description || data.message || 'Cart add failed');
          }

          await openCartAfterAdd(data);
          await applyBundleDiscountCode();
        } catch (e) {
          console.error(e);
          if (label) {
            label.textContent = 'Error – try again';
            window.setTimeout(() => {
              label.textContent = prev;
            }, 2500);
          }
        } finally {
          if (label && label.textContent === (config.loadingLabel || 'Adding...')) {
            label.textContent = prev;
          }
          renderSummary();
        }
      });
    }

    function setSealChoice(choice) {
      const scope = els.sealScope;
      if (!scope) return;
      scope.querySelectorAll('.sls-option-container').forEach((option) => {
        if (!(option instanceof HTMLElement)) return;
        const text = (option.textContent || '').toLowerCase();
        const isOne = text.includes('one-time') || text.includes('one time');
        const active = choice === 'one-time' ? isOne : !isOne && text.trim() !== '';
        option.classList.toggle('sls-active', active);
        const input = option.querySelector('.sls-option[type="radio"]');
        if (input instanceof HTMLInputElement) input.checked = active;
      });
    }

    function syncPlanToSeal(planId) {
      const id = extractNumericString(planId);
      if (!id || !els.sealScope) return;
      lastKnownSellingPlanId = id;
      const hiddenSelect = els.sealScope.querySelector('select.sls-select');
      if (hiddenSelect instanceof HTMLSelectElement && hiddenSelect.value !== id) {
        hiddenSelect.value = id;
        hiddenSelect.dispatchEvent(new Event('input', { bubbles: true }));
        hiddenSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      els.sealScope.querySelectorAll('input[name="selling_plan"], input[data-sls-selling_plan]').forEach((input) => {
        if (input instanceof HTMLInputElement) input.value = id;
      });
    }

    function bindPurchaseUi() {
      const ui = root.querySelector('[data-byb-purchase]');
      if (!ui) return;
      const once = ui.querySelector('[data-byb-purchase-choice][value="one-time"]');
      const sub = ui.querySelector('[data-byb-purchase-choice][value="subscription"]');
      const select = ui.querySelector('[data-byb-purchase-plan]');

      const applyChoice = (choice) => {
        const subscription = choice !== 'one-time';
        ui.classList.toggle('is-subscription', subscription);
        lastKnownSubscriptionChoice = subscription ? 'flexible' : 'one-time';
        setSealChoice(subscription ? 'flexible' : 'one-time');
        if (subscription && select instanceof HTMLSelectElement) syncPlanToSeal(select.value);
      };

      let touched = false;
      once?.addEventListener('change', () => {
        touched = true;
        if (once instanceof HTMLInputElement && once.checked) applyChoice('one-time');
      });
      sub?.addEventListener('change', () => {
        touched = true;
        if (sub instanceof HTMLInputElement && sub.checked) applyChoice('subscription');
      });
      select?.addEventListener('change', () => {
        touched = true;
        if (sub instanceof HTMLInputElement && !sub.checked) {
          sub.checked = true;
        }
        applyChoice('subscription');
      });

      const kick = () => {
        if (touched) return;
        if (once instanceof HTMLInputElement && once.checked) applyChoice('one-time');
        else applyChoice('subscription');
      };
      kick();
      window.setTimeout(kick, 400);
      window.setTimeout(kick, 1200);
    }

    renderAll();
    bindSealObserver();
    bindSealSellingPlanListener();
    bindSealFormIntercept();
    bindPurchaseUi();

  }

  function normalizePackPath(href) {
    if (!href) return '';
    try {
      const path = new URL(href, window.location.origin).pathname;
      return path.replace(/\/$/, '') || '/';
    } catch {
      return href.replace(/\/$/, '') || '/';
    }
  }

  function initPackSwitcher(scope) {
    const currentPath = normalizePackPath(window.location.pathname);
    scope.querySelectorAll('.pack-btn').forEach((btn) => {
      if (normalizePackPath(btn.getAttribute('href')) === currentPath) {
        btn.classList.add('active');
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-build-your-bundle]').forEach(initBuilder);
    document.querySelectorAll('[data-build-your-bundle-section]').forEach((scope) => {
      initPackSwitcher(scope);
      scope.classList.add('byb-ready');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-build-your-bundle]').forEach(initBuilder);
    e.target.querySelectorAll('[data-build-your-bundle-section]').forEach((scope) => {
      initPackSwitcher(scope);
      scope.classList.add('byb-ready');
    });
  });
})();
